export const envMode = function (): string {
    // @ts-ignore
    if (typeof process != "undefined" && process && process.env && process.env.NODE_ENV) return process.env.NODE_ENV;
    // @ts-ignore
    else if (import.meta?.env?.MODE) return import.meta.env.MODE;
    else return "ENV UNKNOWN";
};

export class UrlsVO {
    dominio: string;
    main: string;
    api: string;

    constructor() {
        this.dominio = "adm.gomode.com.br";
        this.main = `https://${this.dominio}`;
        this.api = this.main + "/api";

        if (envMode() != "production") {
            this.dominio = "localhost";
            this.main = `http://${this.dominio}:8081`;
            this.api = `http://${this.dominio}:8080/gomode/api`;
            console.log(`-- Using ${this.api} as api URL`);
        }
    }
}
const URLS = new UrlsVO();

export default URLS;
